import SEOHead from "@/components/feature/SEOHead";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { faqs } from "./components/FAQ";
import Navbar from "@/components/feature/Navbar";
import DiagnosticVideo from "@/components/feature/DiagnosticVideo";
import Footer from "@/components/feature/Footer";
import FloatingButton from "@/components/feature/FloatingButton";
import Avis from "@/components/feature/Avis";
import Hero from "./components/Hero";
import Reassurances from "./components/Reassurances";
import Presentation from "./components/Presentation";
import Manuel from "./components/Manuel";
import Electrique from "./components/Electrique";
import Pieces from "./components/Pieces";
import Marques from "./components/Marques";
import ReparerPlutot from "./components/ReparerPlutot";
import FAQ from "./components/FAQ";
import CTAAppel from "./components/CTAAppel";
import Galerie from "./components/Galerie";
import Maillage from "./components/Maillage";
import Formulaire from "./components/Formulaire";

export default function ReparationPage() {
  return (
    <div className="font-sans">
      <SEOHead
        title="Réparation Volet Roulant Strasbourg | Toutes Marques"
        description="Réparation de volet roulant manuel et électrique à Strasbourg et dans le Bas-Rhin. Toutes marques, intervention 24h, devis gratuit. 03 74 47 32 40."
        path="/reparation-volet-roulant"
        type="service"
        serviceType="Réparation de volet roulant"
        faqs={faqs}
        breadcrumbs={[{ label: "Accueil", href: "/" }, { label: "Réparation volet roulant" }]}
      />
      <Navbar />
      <Breadcrumb items={[{ label: "Accueil", href: "/" }, { label: "Réparation volet roulant" }]} />
      <main>
        <Hero />
        <DiagnosticVideo />
        <Reassurances />
        <Presentation />
        <Manuel />
        <Electrique />
        <Pieces />
        <Marques />
        <ReparerPlutot />
        <FAQ />
        <CTAAppel />
        <Galerie />
        <Maillage />
        <Formulaire />
        <CTAAppel />
        <Avis />
      </main>
      <Footer />
      <FloatingButton />
    </div>
  );
}